import { SideNavigationLink } from "../../components/SideNavigation";

/**
 * Sub-navigation shared by the two Company Info > Meetings admin pages: the existing
 * "All Meetings" page and the "Meeting Coverage" page (PY-12529). Kept in one place so
 * both pages render an identical legacy sub-nav and stay reachable from either tab.
 */
export const COMPANY_MEETINGS_NAV_LINKS: SideNavigationLink[] = [
	{ key: "all-meetings", label: "All Meetings", href: "/company/meetings" },
	{ key: "meeting-coverage", label: "Meeting Coverage", href: "/company/meetings/coverage" },
];
